<template>
	<button class="yj-button" @click="handleClick" :disabled="buttonDisabled || loading" type="button" :class="[
      type ? 'yj-button--' + type : '',
      buttonSize ? 'yj-button--' + buttonSize : '',
      {
        'is-disabled': buttonDisabled,
        'is-loading': loading,
        'is-plain': plain,
        'is-round': round,
        'is-circle': circle
      }
    ]">
		<i class="yj-icon-loading" v-if="loading"></i>
		<i :class="icon" v-if="icon && !loading"></i>
		<span v-if="$slots.default">
			<slot></slot>
		</span>
	</button>
</template>
<script>
	export default {
		name: 'YjButton',

		inject: {
			yjForm: {
				default: ''
			},
			yjFormItem: {
				default: ''
			}
		},

		props: {
			type: {
				type: String,
				default: 'default'
			},
			size: String,
			icon: {
				type: String,
				default: ''
			},
			loading: Boolean,
			disabled: Boolean,
			plain: Boolean,
			round: Boolean,
			circle: Boolean
		},

		computed: {
			_yjFormItemSize() {
				return (this.yjFormItem || {}).yjFormItemSize;
			},
			buttonSize() {
				return this.size || this._yjFormItemSize || (this.$YJ || {}).size;
			},
			buttonDisabled() {
				return this.disabled || (this.yjForm || {}).disabled;
			}
		},

		methods: {
			handleClick(evt) {
				this.$emit('click', evt);
			}
		}
	};
</script>



// WEBPACK FOOTER //
// src/components/button/src/button.vue